import { useEffect } from 'react'
import { useRootStore } from 'stores/RootStore'
import { FontPairing } from 'hooks/queries/fontPairings'

/**
 * Preloads fonts from font pairings and custom fonts to avoid render delays when switching between font pairings.
 */
export const useFontPreloading = (
  fontPairings: FontPairing[] | undefined,
  customFonts: Array<{ name: string; font_family: string }>,
) => {
  const { googleFonts, blazeFonts, customFonts: customFontsStore } = useRootStore()

  useEffect(() => {
    // Load font pairings
    if (fontPairings) {
      const headerFontFamilies = fontPairings
        .map((fp) => fp.header_font_config?.family)
        .filter((family): family is string => !!family)

      const uniqueFamilies = [...new Set(headerFontFamilies)]

      if (googleFonts.ready) {
        uniqueFamilies.forEach((family) => googleFonts.load(family))
      }

      if (blazeFonts.ready) {
        uniqueFamilies.forEach((name) => blazeFonts.load(name))
      }
    }

    // Load custom fonts
    if (customFonts[0]) {
      customFontsStore.load(customFonts[0].name)
    }
  }, [fontPairings, googleFonts, blazeFonts, customFonts, customFontsStore])
}
